"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountSummaryBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Tooltip = _interopRequireDefault(require("../../common/Tooltip/Tooltip"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bem = (0, _cssClassesHelper.getBEMClasses)('wallets-account-summary');
var AccountSummaryBox = exports.AccountSummaryBox = function AccountSummaryBox(_ref) {
  var value = _ref.value,
    label = _ref.label,
    labelTooltip = _ref.labelTooltip,
    highlight = _ref.highlight,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(bem('box'), className)
  }, labelTooltip ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    text: labelTooltip
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(bem('title', 'with-tooltip'))
  }, label)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: bem('title')
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(bem('value'), highlight && bem('highlight'))
  }, value), /*#__PURE__*/_react["default"].createElement("div", {
    className: bem('footer')
  }, children));
};